import { writable } from "svelte/store";

type PreselectedValues = Record<string, boolean>;

export const preselected = writable<PreselectedValues>({});

export function flushPreselected() {
  preselected.set({});
}
